import MedicalFormSuccessMessage from '../../pages/gym-medical-form/MedicalFormSuccessMessage';

const MedicalFormSuccessModal = () => {
  const successMessageStatus = 'MEDICAL_FORM_VALID_SUCCESS_MESSAGE_CONTENT';

  return (
    <div>
      <MedicalFormSuccessMessage successMessage={successMessageStatus} />
    </div>
  );
};
export default MedicalFormSuccessModal;
